module.exports = __webpack_public_path__ + "img/Contabilidad.c0f5fd5a.svg";